import * as React from 'react';
import { memo } from 'react';

const SvgArrowsCounterClockwise = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.364 5.452H1.739V2.827", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.402 3.598a4.807 4.807 0 0 0-6.804 0L1.74 5.452M9.636 8.548h2.625v2.625", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.598 10.402a4.807 4.807 0 0 0 6.804 0l1.859-1.854", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgArrowsCounterClockwise);

export { Memo as default };
